import React from "react";

function GuardPrinciples() {
    return (
        <div>
            <h2>Principles of Working in the Private Security Industry</h2>
            <p>
                This module introduces the structure, purpose, and expectations of the private security industry. It outlines the role of the SIA, licensing requirements, and the professional standards expected of all licensed security personnel.
            </p>

            <h3>The Role of the SIA</h3>
            <ul>
                <li>Regulates the private security industry in the UK</li>
                <li>Issues licenses and approves training providers</li>
                <li>Sets and enforces standards of conduct and competence</li>
                <li>Protects the public by ensuring only fit and proper individuals are licensed</li>
            </ul>

            <h3>Licensing Requirements</h3>
            <ul>
                <li>Be at least 18 years old</li>
                <li>Hold a valid Emergency First Aid at Work certificate</li>
                <li>Complete an approved SIA training course</li>
                <li>Pass identity verification and criminal background checks</li>
                <li>Renew license every 3 years</li>
            </ul>

            <h3>Legal Responsibilities</h3>
            <ul>
                <li>Comply with the Private Security Industry Act 2001</li>
                <li>Respect human rights and equality legislation</li>
                <li>Understand the limits of your authority</li>
                <li>Use force only when necessary and proportionate</li>
            </ul>

            <h3>Professional Conduct</h3>
            <ul>
                <li>Act with honesty, integrity, and fairness</li>
                <li>Maintain confidentiality and respect privacy</li>
                <li>Follow site-specific policies and procedures</li>
                <li>Dress appropriately and behave professionally at all times</li>
            </ul>

            <h3>Equality & Diversity</h3>
            <ul>
                <li>Treat everyone with respect and dignity</li>
                <li>Challenge discrimination and inappropriate behavior</li>
                <li>Understand cultural differences and communication styles</li>
            </ul>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.gov.uk/government/organisations/security-industry-authority" target="_blank" rel="noreferrer">SIA – Official Website</a></li>
                <li><a href="https://www.legislation.gov.uk/ukpga/2001/12/contents" target="_blank" rel="noreferrer">Private Security Industry Act 2001</a></li>
                <li><a href="https://www.equalityhumanrights.com/en" target="_blank" rel="noreferrer">Equality & Human Rights Commission</a></li>
            </ul>
        </div>
    );
}

export default GuardPrinciples;
